<template>
  <div class="d-grid gap-8">
    <BaseCard
      :title="localStorage.translations.pages.sales_project['material_price-tables']['images_in_reports']"
      v-if="$route.name !== 'SalesProjectCreateContinue'"
      max-width="500"
    >
      <div>
        <BaseInput type="switch" value="true" :disabled="!edit" v-model="workClientProjectShow.images_in_report"/>
      </div>
    </BaseCard>
    <BaseCard
      v-if="companiesConfig.work_type_prices !== '0'"
      :title="localStorage.translations.pages.sales_project['sections']['materialy-i-tseny']"
      class-body="d-grid gap-5"
    >
      <v-form ref="form" lazy-validation v-model="valid">
        <ProjectMaterialsAndPricesTable
          v-if="workClientProjectsWorkTypeAll_project.length ||workClientProjectsWorkTypeDefault.length"
          :itemsDefault="workClientProjectsWorkTypeDefault"
          :items="workClientProjectsWorkTypeAll_project"
          :workTypeList="workTypeGridAll"
          :edit="edit"
          @editing="onEditing"
          :sticky="tableSticky"
        />
        <div v-else class="secondary--text f18 mb-8">
          {{ localStorage.translations.pages.common['text']['net-dannyh'] }}
        </div>
      </v-form>
      <div v-if="edit">
        <div class="d-flex flex-wrap gap-5">
          <BaseButton
            @click="addItem"
            :text="localStorage.translations.pages.common['buttons']['dobavit']"
            default_icon="button-add"
          />
          <BaseButton
            @click="() => onCreateOrUpdate()"
            :text="localStorage.translations.pages.common['buttons']['sohranit-izmeneniya']"
            default_icon="button-save"
            :disabled="!unsaveChanges"
          />
        </div>
      </div>
    </BaseCard>
    <BaseCard
      v-if="companiesConfig.extra_work_price !== '0'
        && (userType !== 'subscriber' ? edit || workClientProjectShow.extra_works_price > 0 : false)"
      :title="localStorage.translations.pages.sales_project['sections']['price_extra']"
      class-body="d-grid gap-5"
    >
      <BaseTableView
        :head="[
          { text: localStorage.translations.pages.sales_project['material_price-tables']['tsena'] },
          { text: localStorage.translations.pages.sales_project['material_price-tables']['purchase_price'] },
          { text: localStorage.translations.pages.sales_project['material_price-tables']['summa'] },
          ]"
        :sticky="tableSticky"
      >
        <tr>
          <td>
            <BaseInput
              v-model="materialsAndPricesData.extra_works_price"
              placeholder="10"
              :max-width="180"
              :view="!edit"
              :view-value="$formatCurrency(workClientProjectShow.extra_works_price) + ' €/' +
                localStorage.translations.pages.common.measure.hours_min"
              input-type="Number"
            >
              <template v-slot:append-outer>
                <div class="mt-1 text-pre">
                  {{ '€/' + localStorage.translations.pages.common.measure.hours_min }}
                </div>
              </template>
            </BaseInput>
          </td>
          <td class="resizeAdditioallTD">
            <BaseInput
              v-model="materialsAndPricesData.extra_works_salary"
              placeholder="10"
              :max-width="180"
              :view="!edit"
              :view-value="workClientProjectShow.extra_works_salary ? ($formatCurrency(workClientProjectShow.extra_works_salary) + ' €/' +
                localStorage.translations.pages.common.measure.hours_min) : '—'"
              input-type="Number"
            >
              <template v-slot:append-outer>
                <div class="mt-1 text-pre">
                  {{ '€/' + localStorage.translations.pages.common.measure.hours_min }}
                </div>
              </template>
            </BaseInput>
          </td>
          <td>
            <div :class="edit ? 'width' : ''">
              <BaseInput
                height="48px"
                v-model="amount"
                readonly
                append-outer-icon="euro"
                :max-width="180"
                placeholder="10"
                :view="!edit"
                :view-value="amount ? amount.toLocaleString('fi-FI', {minimumFractionDigits: 2, maximumFractionDigits: 2,}) + ' €' : '—'"
                input-type="Number"
              />
            </div>
          </td>
        </tr>
      </BaseTableView>
    </BaseCard>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import ProjectMaterialsAndPricesTable from 'components/project/materialsAndPrices/ProjectMaterialsAndPricesTable'
import BaseCard from "components/base/BaseCard.vue";
import BaseButton from "components/base/BaseButton.vue";
import BaseInput from "components/base/BaseInput.vue";

export default {
  name: 'ProjectMaterialsAndPrices',
  props: {
    edit: Boolean,
    createContinue: Boolean,
    projectRequiredData: Object,
    tableSticky: Boolean,
  },
  components: {
    BaseInput,
    BaseButton,
    BaseCard,
    ProjectMaterialsAndPricesTable,
  },
  data() {
    return {
      valid: false,
      workTypeList: [],
      materialsAndPricesData: {
        extra_works_price: '',
        extra_works_salary: '',
      },
      loadingData: false,
    }
  },
  created() {
    this.onDownloadData({})
  },
  mounted() {
    this.onActualData()
    this.onCheckChange({overwrite: true})
  },
  watch: {
    '$route.name': {
      handler: function (val, oldVal) {
        if (oldVal === 'SalesProjectCreate') {
          this.onCheckChange({
            overwrite: true,
          })
        }
      },
      deep: true,
    },
    materialsAndPricesData: {
      handler: function (val, oldVal) {
        if (this.edit) {
          this.onNavigationGuardianCheck({
            data: {
              materialsAndPricesData: this.materialsAndPricesData,
            },
          })
        }
      },
      deep: true,
    },
    workClientProjectShow() {
      this.onActualData()
    },
    edit() {
      if (this.edit) {
        this.onCheckChange({overwrite: true})
        this.onActualData()
      } else {
        this.onDownloadData({update: true})
      }
    },
  },
  computed: {
    ...mapGetters(['inputRules', 'companiesConfig']),
    ...mapGetters('workClientProjectsWorkType', [
      'workClientProjectsWorkTypeDefault',
      'workClientProjectsWorkTypeAll_project',
    ]),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workType', ['workTypeGridAll']),
    ...mapState('navigationGuardian', [
      'navigationGuardianChangeData',
      'navigationGuardianCheckData',
    ]),
    userType() {
      return this.$store.getters['user/userType']
    },
    apiDomain() {
      return this.$store.state.apiDomain
    },
    unsaveChanges() {
      let result = undefined
      const serverData = this.$checkNavigationGuardianChange(
        'workClientProjectsWorkTypeAll_project',
      )
      const clientData = this.$checkNavigationGuardianChange('workClientProjectsWorkTypeDefault')

      if (!!serverData && !!clientData) {
        result = !!serverData.find((i) => i !== false) || !!clientData.find((i) => i !== false)
      }
      return result
    },
    amount() {
      return Number(this?.materialsAndPricesData?.extra_works_price || 0)
      //+ Number(this?.workClientProjectShow?.extra_works_salary || 0)
    },
  },
  methods: {
    ...mapActions('workType', ['onWorkTypeGridAll']),
    ...mapActions('workClientProject', ['onWorkClientProjectUpdate']),
    ...mapActions('workTypeCategory', ['onWorkTypeCategoryGridAll']),
    ...mapActions('workClientProjectsWorkType', [
      'onWorkClientProjectsWorkTypeCreate',
      'onWorkClientProjectsWorkTypeUpdate',
      'onWorkClientProjectsWorkTypeDelete',
      'onWorkClientProjectsWorkTypeAll_project',
      'onWorkClientProjectsWorkTypeDefaultAdd',
      'onWorkClientProjectsWorkTypeCancelChange',
    ]),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapMutations('workClientProjectsWorkType', ['setWorkClientProjectsWorkTypeAll_project']),
    onDownloadData({update}) {
      // console.log('onDownloadData')
      this.loadingData = true
      const wokrsQuerie =
        this.$route.name !== 'SalesProjectCreate'
          ? this.onWorkClientProjectsWorkTypeAll_project(this.$route.params.id).then((resp) => {
            if (this.edit) {
              this.onCheckChange({
                overwrite: true,
              })
            }
          })
          : true
      let queries = [wokrsQuerie]
      if (!update) {
        const editQueries = [this.onWorkTypeCategoryGridAll(), this.onWorkTypeGridAll()]
        queries.push(...editQueries)
      }
      Promise.all(queries).then(() => (this.loadingData = false))
    },
    onCheckChange({overwrite}) {
      this.onNavigationGuardianCheck({
        data: {
          workClientProjectsWorkTypeDefault: this.workClientProjectsWorkTypeDefault,
          workClientProjectsWorkTypeAll_project: this.workClientProjectsWorkTypeAll_project,
        },
        overwrite,
      })
    },
    onEditing(value) {
      this.onNavigationGuardianCheck({
        data: {
          [value.name]: this[value.name],
        },
        editingArrayData: value,
      })
    },
    validate() {
      return this.workClientProjectsWorkTypeAll_project.length ||
      this.workClientProjectsWorkTypeDefault.length
        ? this.$refs.form.validate()
        : true
    },
    addItem() {
      this.onWorkClientProjectsWorkTypeDefaultAdd()
    },
    onActualData() {
      if (this.workClientProjectShow) {
        if (
          this.workClientProjectShow.extra_works_price &&
          this.workClientProjectShow.extra_works_price > 0
        ) {
          this.materialsAndPricesData.extra_works_price =
            this.workClientProjectShow.extra_works_price.toString()
        }
        if (
          this.workClientProjectShow.extra_works_salary &&
          this.workClientProjectShow.extra_works_salary > 0
        ) {
          this.materialsAndPricesData.extra_works_salary =
            this.workClientProjectShow.extra_works_salary.toString()
        }
        if (this.edit) {
          this.onNavigationGuardianCheck({
            data: {
              materialsAndPricesData: this.materialsAndPricesData,
            },
            overwrite: true,
          })
        }
      }
    },
    async onUpdateExtraPrice(global) {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('materialsAndPricesData')) {
          let data = {
            extra_works_price: this.materialsAndPricesData.extra_works_price,
            extra_works_salary: this.materialsAndPricesData.extra_works_salary,
            business_segment_id: this.workClientProjectShow.business_segment_id,
            end_date: this.workClientProjectShow.end_date,
            project_type_id: this.workClientProjectShow.project_type_id,
            start_date: this.workClientProjectShow.start_date,
          }
          if (global) {
            this.onNavigationGuardianCheck({
              data: {
                materialsAndPricesData: this.materialsAndPricesData,
              },
              overwrite: true,
            })
            resolve(data)
          } else {
            this.loadingData = true
            let data2 = {
              id: this.workClientProjectShow.id,
              name:
                (this.projectRequiredData && this.projectRequiredData.name) ||
                this.workClientProjectShow.name,
              work_client_id:
                (this.projectRequiredData && this.projectRequiredData.work_client_id) ||
                this.workClientProjectShow.work_client.id,
            }
            data = {...data, ...data2}
            await this.onWorkClientProjectUpdate(data)
              .then((resp) => {
                this.onNavigationGuardianCheck({
                  data: {
                    materialsAndPricesData: this.materialsAndPricesData,
                  },
                  overwrite: true,
                })
                resolve(resp)
                this.loadingData = false
              })
              .catch(() => {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common['notifications']['oshibka'],
                    IsError: true,
                  },
                  {root: true},
                )
                this.loadingData = false
              })
          }
        } else resolve(true)
      })
    },
    async onCreateOrUpdate(global) {
      return new Promise(async (resolve, reject) => {
        if (this.validate()) {
          this.loadingData = true
          const serverArray = this.$checkNavigationGuardianChange(
            'workClientProjectsWorkTypeAll_project',
          )
          const clientArray = this.$checkNavigationGuardianChange(
            'workClientProjectsWorkTypeDefault',
          )
          let requests = []
          const deleteOrUpdateRequests = async () => {
            console.log('???????')
            for (let serverKey in serverArray) {
              let item = this.workClientProjectsWorkTypeAll_project[serverKey]
              if (serverArray[serverKey] === 'delete') {
                requests.push(this.onWorkClientProjectsWorkTypeDelete(item.id))
              } else if (serverArray[serverKey] === 'edit') {
                let data = {
                  id: item.id,
                  project_id: this.$route.params.id,
                  work_type_id: item.work_type.id,
                  work_type_category_id: item.work_type_category.id,
                  size: item.size,
                  price: item.price,
                  salary: item.salary,
                  is_hourly: item.is_hourly,
                  hours: item.is_hourly == 1 ? item.hours : 0,
                }
                requests.push(this.onWorkClientProjectsWorkTypeUpdate(data))
              }
            }
          }
          const createRequests = async () => {
            for (let clientKey in clientArray) {
              if (clientArray[clientKey]) {
                let item = this.workClientProjectsWorkTypeDefault[clientKey]
                let data = {
                  project_id: this.$route.params.id,
                  work_type_id: item.work_type.id,
                  work_type_category_id: item.work_type_category.id,
                  size: item.size,
                  price: item.price,
                  salary: item.salary,
                  is_hourly: item.is_hourly,
                  hours: item.is_hourly == 1 ? item.hours : 0,
                }
                requests.push(await this.onWorkClientProjectsWorkTypeCreate(data))
              }
            }
          }
          await deleteOrUpdateRequests()
          await createRequests()
          // console.log('requests', requests)
          if (requests.length) {
            Promise.all(requests)
              .then(async (resp) => {
                if (!global) {
                  // console.log('!global', resp)
                  await this.onDownloadData({update: true})
                  resolve(resp)
                } else {
                  // console.log('global', resp)
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common.notifications[
                          'izmeneniya-uspeshno-sohraneny'
                          ],
                      IsError: false,
                    },
                    {root: true},
                  )
                }
                this.loadingData = false
              })
              .catch((err) => {
                reject(err)
                this.loadingData = false
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common['notifications']['oshibka'],
                    IsError: true,
                  },
                  {root: true},
                )
              })
          } else {
            this.loadingData = false
            resolve(true)
          }
        } else {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'fill_in_required_fields'
                  ],
              IsError: true,
            },

            {root: true},
          )
          reject(false)
        }
      })
    },
  },
  beforeDestroy() {
    this.setWorkClientProjectsWorkTypeAll_project([])
  },
}
</script>
<style scoped lang="scss">
:deep() table.table_list_view tr th:first-child,
table.table_list_view tr td:first-child {
  width: 280px !important;
}

.resizeAdditioallTD {
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    width: 280px !important;
  }

}

:deep().v-input.v-input--is-disabled .v-input__control .v-input__slot {
  background: none !important;
}
</style>